export const isPhotoInContest = (media) => {
    if (!media) return false;
    const date = media?.media?.[0].created_at;
    if (!date) return false;
    return isDateInContest(date);
};

export const isDateInContest = (date) => {
    const mediaCreatedTimestamp = Date.parse(date);
    const invalidDate = isNaN(mediaCreatedTimestamp);
    if (invalidDate) return false;
    const startContestDate = '16 Jun 2023 00:00:01';
    const endContestDate = '31 Jul 2023 23:59:00';
    const startContestTimestamp = Date.parse(startContestDate);
    const endContestTimestamp = Date.parse(endContestDate);
    return mediaCreatedTimestamp > startContestTimestamp && mediaCreatedTimestamp < endContestTimestamp;
};
